'use client';

import cn from 'classnames';
import { ChangeEvent, forwardRef } from 'react';
import { Button, Input, InputProps } from '@/shared/ui/core';
import { useClearableInput } from '../lib/use-clearable-input';
import styles from './clearable-input.module.scss';


type ClearableInputProps = Omit<InputProps, 'value' | 'onChange'> & {
    value   : string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onClear?: () => void;
}

export const ClearableInput = forwardRef<HTMLInputElement, ClearableInputProps>(function ClearableInput (
    { value, onChange, onClear: onClearProp, ...props },
    ref,
) {
    const { value: resolvedValue, onChange: resolvedOnChange, onClear, Icon } = useClearableInput({
        value,
        onChange,
        onClear: onClearProp,
    });

    return (
        <Input
            ref={ ref }
            value={ resolvedValue }
            onChange={ resolvedOnChange }
            rightSlot={
                <Button
                    tabIndex={ -1 }
                    aria-hidden
                    aria-label='Clear field'
                    className={ cn(styles.button, { [styles.has_value]: resolvedValue }) }
                    onClick={ onClear }
                    variant='naked'
                >
                    <Icon size={ 20 }/>
                </Button>
        }
            data-template='clearable-input'
            { ...props }
        />
    );
});
